import React from "react"
import '../sass/home.scss'
import {Redirect} from "react-router"

export default () => {
    return (
        <Redirect to="/" />
    );
}
